import { render, staticRenderFns } from "./BaseSeparator.vue?vue&type=template&id=7602a462"
import script from "./BaseSeparator.vue?vue&type=script&lang=js"
export * from "./BaseSeparator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports